
import {
  PinInput,
  PinInputField,
  HStack,
  chakra,
  Button,
  Text,
  Flex,
  useToast,
} from "@chakra-ui/react";
import { Link, useSearchParams } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { setCookie } from "cookies-next";
import { sendLoginOTP, verifyLoginOTP } from "../../../API/auth";
import { DASH_ROUTES } from "../../../utils/routes";
import { toaster } from "../../../utils/toast";
import { initiateVerifyDomain, verifyDomain } from "../../../API/account/domains";
import { confirmEmailSenderVerification, initiateEmailSenderVerification } from "../../../API/account/senderId";

const ConfirmSenderEmail = ({close, emailSenderUid}:{ close: () => void, emailSenderUid:string}) => {
 

  // email
  // @ts-ignore

  // code
  console.log("confirmCheck",emailSenderUid)
  const [code, setCode] = useState<string | number>("");
  const queryClient = useQueryClient();

  const toast = useToast();

  const { mutate, isLoading } = useMutation(confirmEmailSenderVerification, {
    onSuccess(data) {
      const success = { ...data };
      toaster(toast, success);
      queryClient.invalidateQueries(['emailSenderIDData']);
      close && close();
    
    },

    onError(data: any) {
      const errors = { ...data };
      toaster(toast, errors);
    },
  });

  // resend code
  const { mutate: resendCode, isLoading: resendLoading } = useMutation(
    initiateEmailSenderVerification,
    {
      onSuccess(data) {
        const success = { ...data };
        toaster(toast, success);
      },

      onError(data: any) {
        const errors = { ...data };
        toaster(toast, errors);
      },
    }
  );

  return (
      <chakra.form
        onSubmit={(e) => {
          e.preventDefault();

          mutate({
            code,emailSenderUid
          });
        }}
      >
        <HStack justifyContent={"center"}>
          <PinInput
            onChange={(value) => {
              setCode(value);
            }}
          >
            <PinInputField
              borderRadius={"8px"}
              borderColor="grays.5"
              _hover={{
                borderColor: "grays.5",
              }}
              color="grays.9"
              _placeholder={{
                color: "grays.6",
              }}
              w="56px"
              h="56px"
              py="18px"
              px="13px"
            />
            <PinInputField
              borderRadius={"8px"}
              borderColor="grays.5"
              _hover={{
                borderColor: "grays.5",
              }}
              color="grays.9"
              _placeholder={{
                color: "grays.6",
              }}
              w="56px"
              h="56px"
              py="18px"
              px="13px"
            />
            <PinInputField
              borderRadius={"8px"}
              borderColor="grays.5"
              _hover={{
                borderColor: "grays.5",
              }}
              color="grays.9"
              _placeholder={{
                color: "grays.6",
              }}
              w="56px"
              h="56px"
              py="18px"
              px="13px"
            />
            <PinInputField
              borderRadius={"8px"}
              borderColor="grays.5"
              _hover={{
                borderColor: "grays.5",
              }}
              color="grays.9"
              _placeholder={{
                color: "grays.6",
              }}
              w="56px"
              h="56px"
              py="18px"
              px="13px"
            />
            <PinInputField
              borderRadius={"8px"}
              borderColor="grays.5"
              _hover={{
                borderColor: "grays.5",
              }}
              color="grays.9"
              _placeholder={{
                color: "grays.6",
              }}
              w="56px"
              h="56px"
              py="18px"
              px="13px"
            />
          </PinInput>
        </HStack>

        {/* Resend code */}
        <Flex w="full">
          <HStack mx="auto" mt="24px" spacing={"8px"}>
            <Text as="span" color="grays.9" fontWeight={"medium"} fontSize="xs">
              Didn’t recieve a code?
            </Text>

            <Button
              type="button"
              bg="green.500"
              color="white"
              size="xs"
              colorScheme={"green"}
              rounded="2px"
              py="4px"
              px="10px"
              onClick={() => {
                resendCode({email_sender_uid: emailSenderUid});
              }}
              isLoading={resendLoading}
              isDisabled={isLoading}
            >
              Resend
            </Button>
          </HStack>
        </Flex>

        <Flex flexDir={"column"}   pb={5}>
          <Button
            isLoading={isLoading}
            isDisabled={code?.toString()?.length !== 5}
            type="submit"
            w="full"
            colorScheme={"primary"}
            mt="10px"          >
            Continue
          </Button>

          {/* <Link to="/login">
            <Text
              color="primary.500"
              textDecor={"underline"}
              mx="auto"
              mt={3}
              textAlign="center"
              fontSize={"xs"}
              fontWeight={500}
            >
              Back to login
            </Text>
          </Link> */}
        </Flex>
      </chakra.form>
   
  );
};

export default ConfirmSenderEmail;
